import React, { useEffect, useState } from 'react'
import GoogleMicrosoftAuth from '../components/Auth/GoogleMicrosoftAuth'
import EmailStep from '../components/Auth/EmailStep'
import AuthShell from '../components/Auth/AuthShell'
import { Divider, Link, Stack, Typography } from '@mui/material'
import { Link as RouterLink, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getSignupEnabledCached } from '../services/auth/signupSession'

const Login: React.FC = () => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()
    const needsMfaSetup = searchParams.get('signup') === 'mfa_required'
    const [showGoogleMicrosoftAuth, setShowGoogleMicrosoftAuth] = useState(true)
    const [showEmailStep, setShowEmailStep] = useState(true)
    const [signupEnabled, setSignupEnabled] = useState(false)

    useEffect(() => {
        let ignore = false
        getSignupEnabledCached().then((enabled) => {
            if (!ignore) setSignupEnabled(enabled)
        })
        return () => {
            ignore = true
        }
    }, [])

    return (
        <AuthShell>
            <Stack justifyContent="center" alignItems="stretch" width={400} p={2} spacing="12px">
                {showGoogleMicrosoftAuth && (
                    <Typography variant="h6" align="center" sx={{ width: '100%' }}>
                        {t('login.welcome')}
                    </Typography>
                )}
                {/* Only on the initial state, same as the free-trial link below — mid
                    password/MFA steps it would be a distraction, and once any real
                    interaction starts this has served its purpose. */}
                {needsMfaSetup && showGoogleMicrosoftAuth && showEmailStep && (
                    <Typography variant="body2" align="center" color="text.secondary">
                        {t('login.finish_setup_message')}
                    </Typography>
                )}
                <Stack sx={{ p: 2, width: '100%', padding: 2 }}>
                    {showGoogleMicrosoftAuth && (
                        <GoogleMicrosoftAuth
                            onMfaRequired={() => setShowEmailStep(false)}
                            signupEnabled={signupEnabled}
                        />
                    )}
                    {showGoogleMicrosoftAuth && <Divider sx={{ my: 2 }}>{t('common.or')}</Divider>}
                    {showEmailStep && <EmailStep onStartEmailAuth={() => setShowGoogleMicrosoftAuth(false)} />}
                    {/* Only on the initial state — mid password/MFA steps it would be a distraction.
                        Also hidden while signup itself is disabled, so there's nothing to invite
                        someone into that would just 503 on submit. */}
                    {showGoogleMicrosoftAuth && showEmailStep && signupEnabled && (
                        <Typography variant="body2" align="center" color="text.secondary" sx={{ mt: 2 }}>
                            {t('login.no_account')}{' '}
                            <Link
                                component={RouterLink}
                                to="/signup"
                                variant="body2"
                                sx={{ verticalAlign: 'baseline' }}
                            >
                                {t('login.start_trial_link')}
                            </Link>
                        </Typography>
                    )}
                </Stack>
            </Stack>
        </AuthShell>
    )
}

export default Login
